import { Group } from 'models/groups'
import api from './api'

export const fetchGroups = async () => {
    const resp = await api.get<Group>(`/groups`)

    return resp.data
}
